export default {"src":"/_next/static/image/public/images/ic_bell_notify_white.05b607b8cf09745d933301e6706a5140.svg","height":14,"width":14};